var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 33,
    viewBox: "0 0 246 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49356 9.15137H23.1249C23.4337 9.15137 23.7299 9.27405 23.9483 9.49243C24.1667 9.71081 24.2893 10.007 24.2893 10.3158V20.7959C24.2893 22.0313 23.7986 23.216 22.9251 24.0895C22.0516 24.963 20.8668 25.4538 19.6315 25.4538H7.98693C6.7516 25.4538 5.56686 24.963 4.69335 24.0895C3.81984 23.216 3.3291 22.0313 3.3291 20.7959V10.3158C3.3291 10.007 3.45179 9.71081 3.67016 9.49243C3.88854 9.27405 4.18473 9.15137 4.49356 9.15137V9.15137Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 31.2759H31.2759",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2891 11.48H26.618C27.8533 11.48 29.038 11.9707 29.9116 12.8442C30.7851 13.7177 31.2758 14.9025 31.2758 16.1378C31.2758 17.3731 30.7851 18.5579 29.9116 19.4314C29.038 20.3049 27.8533 20.7956 26.618 20.7956H24.2891",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82227 1V3.32892",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4668 1V3.32892",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6445 1V3.32892",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.293 25.7819C234.852 24.8847 237.019 23.122 238.418 20.7981C239.148 21.8339 240.158 22.6414 241.329 23.127C241.683 23.2769 242.068 23.3369 242.451 23.3015C242.834 23.2662 243.202 23.1367 243.522 22.9245C243.843 22.7124 244.106 22.4242 244.288 22.0856C244.47 21.7471 244.566 21.3688 244.566 20.9844V14.9059C244.566 14.5215 244.47 14.1432 244.288 13.8046C244.106 13.4661 243.843 13.1779 243.522 12.9657C243.202 12.7536 242.834 12.6241 242.451 12.5887C242.068 12.5534 241.683 12.6134 241.329 12.7633C240.154 13.2433 239.144 14.0519 238.418 15.0922C236.089 11.4591 229.754 8.64111 223.396 8.64111C220.962 8.6959 218.646 9.7015 216.944 11.4426C215.242 13.1837 214.289 15.522 214.29 17.9568C214.44 20.3909 215.539 22.6691 217.351 24.302C219.162 25.935 221.542 26.7924 223.978 26.6902C224.677 26.6902 225.795 26.6902 226.494 26.6902",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222.441 16.7693C223.084 16.7693 223.606 16.248 223.606 15.6049C223.606 14.9618 223.084 14.4404 222.441 14.4404C221.798 14.4404 221.277 14.9618 221.277 15.6049C221.277 16.248 221.798 16.7693 222.441 16.7693Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.648 9.03681C222.441 6.2654 226.657 3.14465 235.995 4.21595C235.006 6.89908 235.006 9.84705 235.995 12.5302",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.932 22.2187C224.35 24.2879 225.554 26.1141 227.292 27.313C229.03 28.5119 231.164 28.9899 233.247 28.6465L230.895 20.9844",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.186 1L89.1104 13.809L101.919 9.73343C101.919 7.41718 100.999 5.1958 99.3614 3.55796C97.7236 1.92013 95.5022 1 93.186 1V1Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.946 1.04658L86.7815 1C83.7875 1 80.8607 1.88783 78.3713 3.5512C75.8819 5.21458 73.9416 7.57881 72.7959 10.3449C71.6501 13.111 71.3503 16.1547 71.9344 19.0912C72.5185 22.0277 73.9603 24.725 76.0774 26.8421C78.1944 28.9592 80.8918 30.4009 83.8282 30.985C86.7647 31.5691 89.8085 31.2693 92.5746 30.1236C95.3406 28.9778 97.7049 27.0376 99.3683 24.5481C101.032 22.0587 101.919 19.132 101.919 16.1379C101.919 15.742 101.919 15.3694 101.919 14.9735",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.288 23.1248C83.9311 23.1248 84.4525 22.6035 84.4525 21.9604C84.4525 21.3172 83.9311 20.7959 83.288 20.7959C82.6449 20.7959 82.1235 21.3172 82.1235 21.9604C82.1235 22.6035 82.6449 23.1248 83.288 23.1248Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7948 12.6443C80.4379 12.6443 80.9593 12.123 80.9593 11.4799C80.9593 10.8368 80.4379 10.3154 79.7948 10.3154C79.1517 10.3154 78.6304 10.8368 78.6304 11.4799C78.6304 12.123 79.1517 12.6443 79.7948 12.6443Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.933 19.6312C95.5761 19.6312 96.0975 19.1098 96.0975 18.4667C96.0975 17.8236 95.5761 17.3022 94.933 17.3022C94.2899 17.3022 93.7686 17.8236 93.7686 18.4667C93.7686 19.1098 94.2899 19.6312 94.933 19.6312Z",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_1345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.459 1.14307V6.28592C143.459 7.80145 144.08 9.2549 145.185 10.3265C146.29 11.3982 147.789 12.0002 149.352 12.0002C150.915 12.0002 152.414 11.3982 153.519 10.3265C154.624 9.2549 155.245 7.80145 155.245 6.28592V1.14307",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.352 1.14307V30.8574",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.102 30.8574C170.038 30.8574 166.141 29.2921 163.268 26.5058C160.394 23.7195 158.78 19.9406 158.78 16.0002C158.78 12.0599 160.394 8.28088 163.268 5.49462C166.141 2.70837 170.038 1.14307 174.102 1.14307",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.102 24C171.914 24 169.816 23.1571 168.268 21.6569C166.721 20.1566 165.852 18.1217 165.852 16C165.852 13.8783 166.721 11.8434 168.268 10.3431C169.816 8.84286 171.914 8 174.102 8",
    stroke: "#DF7D76",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    fill: "white",
    transform: "translate(142.28)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.3fa29e9ab438d85256dac2fc419f454f.svg";
export { ForwardRef as ReactComponent };